import { Box, Container, Link, Stack, Typography } from '@mui/material';
import React from 'react';
import { footerNavLinks } from './Configuration/navlinks';
import { BrandMark } from '../BrandMark/BrandMark';
import { APP_VERSION } from '../../config/version';
import styles from './footer.module.css';

export function Footer() {
  return (
    <footer>
      <Box
        sx={{
          backgroundColor: 'var(--topbar)',
          color: 'var(--text)',
          width: '100%',
          paddingTop: 1.5,
          paddingBottom: 1,
          marginTop: 4,
        }}
      >
        <Container maxWidth="xl" sx={{ minHeight: '100%', position: 'relative' }}>
          <Stack sx={{ height: '100%' }}>
            <p style={{ textAlign: 'center' }}>Having trouble? Feel free to reach out to us at&nbsp;
              <a href='mailto:help@thedesirecompany.com' rel='noreferrer' target='_blank' style={{ color: 'var(--accent-text)', textDecoration: 'underline' }}>help@thedesirecompany.com</a>
            </p>
            <Stack sx={{ height: '57px' }} alignItems="center" justifyContent="space-between" direction="row">
              {/* menu */}
              <Stack direction="row" alignItems="center" spacing={2}>
                {footerNavLinks.map((item, index) => (
                  <Link key={index} color="inherit" href={item.link} className="!text-base" target={item.target}>
                    {item.label}
                  </Link>
                ))}
              </Stack>
              <Stack alignItems="center">
                <Typography>&#169; 2025 The Desire Company</Typography>
                <Typography variant="caption" sx={{ opacity: 0.6 }}>{APP_VERSION}</Typography>
              </Stack>

              <Stack direction="row" alignItems="center" spacing={1} className={styles['footer-branding']} sx={{ display: { xs: 'none', sm: 'flex' } }}>
                <BrandMark height={48.5} />
                <Typography>Powered By The Desire Company</Typography>
              </Stack>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </footer>
  );
}
